import { render, staticRenderFns } from "./hold-court-step.vue?vue&type=template&id=6bdcd6de"
import script from "./hold-court-step.vue?vue&type=script&lang=ts"
export * from "./hold-court-step.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports